import { useEffect, useState } from "react";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faBars, faClose, faLayerGroup, faList, faPhoneAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { NavButton } from "../utilities/nav-button";
import { UseCarContext } from "../../services/products/product.context";
import { navigationData } from "../../_helpers/nav-paths";
import { UseAuthentication } from "../../services/authentication/authentication.context";
import { useNavigate } from "react-router-dom";


export const SiteHeader = () => {

    const { isAuthenticated } = UseAuthentication();
    const [showNav, setShowNav] = useState(false);

    const navigateTo = useNavigate();


    const { openSearch } = UseCarContext();

    const toggleNav = () => {
        setShowNav((st) => !st);
    }

    const handleNavigation = (data) => {
        if (data.protected) {
            isAuthenticated === true ? navigateTo(data.path) : console.log('');
        }
    }

    useEffect(() => {
        //auto scroll upon page change
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [])

    return (
        <div>
            <header>
                <div className="contact-info">
                    <span className="contact-unit">
                        <FontAwesomeIcon icon={faPhoneAlt} color="#337d68" />
                        <span className="contact-detail">
                            +237678921882/+237640702678
                        </span>
                    </span>
                    <span className="contact-unit">
                        <FontAwesomeIcon icon={faEnvelope} color="#337d68" />
                        <span className="contact-detail">
                            ngualph12@gmail.com
                        </span>
                    </span>
                </div>
                <div className="header-nav">
                    <img src="/logos/sm-logo.png" alt="" className="app-img" />
                    <div className="nm-slogan">
                        <div className="app-name">RW MOTORS</div>
                        <div className="app-slogan">AUTO SALES</div>
                    </div>
                    <div className={classNames("nav-list", "flx-rw", { "view-list": showNav })}>
                        {navigationData.map((navData) => {
                            return (
                                <NavButton
                                    label={navData.title}
                                    icon={navData.icon}
                                    path={navData.path}
                                />
                            )
                        })}
                    </div>
                    <button
                        className="nav-button toggle-nav"
                        onClick={toggleNav}
                    >
                        <FontAwesomeIcon
                            icon={showNav ? faClose : faBars}
                        />
                    </button>
                    <div className="flx-cnt btn-bx">
                        <button className="srch-button" onClick={() => openSearch()}>
                            <FontAwesomeIcon icon={faSearch} />
                        </button>
                    </div>

                </div>
            </header>
        </div>
    )
}